<template>
  <div class="formdata owner">
    <div class="header-container">
    <h3 id="wish_wallbox_question">Möchten Sie eine Wallbox zum Laden eines E-Autos?</h3>
</div>
    <CustomRadioGroup
        :options="wishWallboxAnswers"
        v-model="selectedAnswer"
        aria-labelledby="wish_wallbox_question"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'wish_wallbox_' + option.value">
          <img :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>

    <button
        class="button button_yellow right"
        v-if="selectedAnswer"
        @click="submit"
    >
      Weiter
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWorkflowStore } from '@/stores/workflow';
import { wishWallboxAnswers, wishWallboxApi } from '@/data/wishWallboxData.js';
import CustomRadioGroup from '@/components/CustomRadioGroup.vue';

const workflowStore = useWorkflowStore();

const getAnswerEventData = (selectedValue) => {
  const fullAnswer = wishWallboxAnswers.find(bt => bt.value === selectedValue);

  if (fullAnswer) {
    return {
      value: selectedValue,
      apiDefinition: wishWallboxApi,
      apiValue: fullAnswer.api,
      available: fullAnswer.available,
    };
  }
  return null;
};

const selectedAnswer = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.wishWallbox || null;
  },
  set(newValue) {
    const eventData = getAnswerEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_WISH_WALLBOX_ANSWER',
      data: eventData,
    });
  },
});

const submit = () => {
  if (selectedAnswer.value) {
    const eventData = getAnswerEventData(selectedAnswer.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};


</script>

